<mat-dialog-content>
  <h2>My snapshots</h2>

  @let snapshotsState = snapshotsState$();
  @switch (snapshotsState.status) {
    @case ('loading') {
      <div class="spinner-container">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    }
    @case ('error') {
      <span class="no-data">Snapshots not available. Try again later.</span>
    }
    @case ('success') {
      @let snapshots = snapshotsState.data;
      @if (snapshots.length === 0) {
        <p class="no-snapshot">
          Snapshot allow to retrieve your selection, zoom and selected layers. Try
          <button matIconButton>
            <mat-icon class="material-symbols-outlined"> screenshot_region</mat-icon></button
          >the button in the tools bar.
        </p>
      } @else {
        <table mat-table [dataSource]="snapshots">
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let snapshot">{{ snapshot.name }}</td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let snapshot">
              {{ snapshot.description }}
            </td>
          </ng-container>

          <ng-container matColumnDef="shared">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let snapshot">
              @if (snapshot.sharedWith.length > 0) {
                <mat-icon [matTooltip]="formatTooltip(snapshot.sharedWith)">group</mat-icon>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let snapshot">{{ snapshot.date | date: 'dd/MM/yyyy' }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let snapshot" class="action-buttons">
              <button
                matIconButton
                aria-label="Edit snapshot"
                matTooltip="Edit snapshot"
                (click)="editSnapshot(snapshot)"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                matIconButton
                aria-label="Delete snapshot"
                matTooltip="Delete snapshot"
                (click)="deleteSnapshotWithConfirm(snapshot)"
              >
                <mat-icon>delete</mat-icon>
              </button>
              <button
                matIconButton
                aria-label="Apply snapshot"
                matTooltip="Apply snapshot"
                (click)="applySnapshot(snapshot)"
              >
                <mat-icon>filter_center_focus</mat-icon>
              </button>
            </td>
          </ng-container>
        </table>
      }
    }
  }

  <div class="shared-title">
    <h2>Shared snapshots</h2>
    <button mat-icon-button (click)="refreshSharedSnapshots()" matTooltip="Refresh">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  @let snapshotsSharedWithMeState = snapshotsSharedWithMeState$();
  @switch (snapshotsSharedWithMeState.status) {
    @case ('loading') {
      <div class="spinner-container">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    }
    @case ('error') {
      <span class="no-data">Snapshots not available. Try again later.</span>
    }
    @case ('success') {
      @let snapshotsSharedWithMe = snapshotsSharedWithMeState.data;
      @if (snapshotsSharedWithMe.length === 0) {
        <p>No one has shared a snapshot with you.</p>
      } @else {
        <table mat-table [dataSource]="snapshotsSharedWithMe">
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let snapshot">{{ snapshot.name }}</td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let snapshot">
              {{ snapshot.description }}
            </td>
          </ng-container>

          <ng-container matColumnDef="shared">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let snapshot">
              <mat-icon
                [matTooltip]="'Shared by ' + snapshot.ownerEmail"
                matTooltipClass="tooltip-wider"
              >
                person</mat-icon
              >
            </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let snapshot">{{ snapshot.date | date: 'dd/MM/yyyy' }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let snapshot" class="action-buttons">
              <button
                matIconButton
                aria-label="Remove shared snapshot from my account"
                matTooltip="Remove shared snapshot from my account"
                (click)="deleteSharedSnapshotWithConfirm(snapshot)"
              >
                <mat-icon>delete</mat-icon>
              </button>
              <button
                matIconButton
                aria-label="Apply snapshot"
                matTooltip="Apply snapshot"
                (click)="applySnapshot(snapshot)"
                class="icon-button-apply"
              >
                <mat-icon>filter_center_focus</mat-icon>
              </button>
            </td>
          </ng-container>
        </table>
      }
    }
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton (click)="cancel()">Close</button>
</mat-dialog-actions>
